import React,{useEffect} from "react";
import { NavLink } from "react-router-dom";
import AOS from 'aos';



const ServicesPageSecondSection = () => {
  useEffect(() => {
    AOS.init();
   
      window.scrollTo(0, 0)
   
  }, [])
  return (
    <div className="container-fluid" id="servicepage-second-section">
      <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="200"  data-aos-duration="1000"	>
        <h3>Our Services We Provide</h3>
      </div>
      <div className="row services-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <div className="col solar-service-col">
          <div className="row">
            <div className="col text-col odd-text-col" style={{textAlign:"left",borderLeft:"1rem solid #304f85"}} data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h1>Solar Services</h1>
              <p>
                Unique Technologies specializes in delivering comprehensive
                solar panel services, offering cutting-edge installation,
                maintenance, and repair solutions. Our team is dedicated to
                providing innovative renewable energy solutions tailored to meet
                the unique needs of each client, ensuring reliable and
                sustainable power generation for homes and businesses alike.
              </p>
              <NavLink to="/solar-services" className="know-more-btn">
                Know More
              </NavLink>
              
            </div>
            <div className="col solar-services-img-col img-col"></div>
          </div>
        </div>
        <hr />
        <div className="col street-light-automation-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
          <div className="row">
          <div className="col street-light-img-col img-col"></div>
            <div className="col text-col even-text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" style={{textAlign:"right" ,borderRight:"1rem solid #304f85"}}>
              <h1>Street Light Automation System</h1>
              <p>
                Unique Technologies excels in providing advanced street light
                automation services, leveraging state-of-the-art technologies to
                optimize energy usage and enhance safety in urban environments.
                With our innovative solutions, we enable efficient remote
                monitoring and control, ensuring well-lit streets while
                minimizing energy consumption and maintenance costs for
                municipalities and organizations.
              </p>
              <NavLink to="/street-light-automation-services" className="know-more-btn">
                Know More
              </NavLink>
            </div>
            
          </div>
        </div>
        <hr />
        <div className="col tube-well-pump-automation-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
          <div className="row">
            <div className="col text-col odd-text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" style={{textAlign:"left",borderLeft:"1rem solid #304f85"}}>
              <h1>
                Tube Well/Pump <br />
                Automation System
              </h1>
              <p>
                Unique Technologies specializes in offering comprehensive tube
                well pump automation services, utilizing cutting-edge technology
                to optimize water resource management. Our solutions enable
                remote monitoring and control of pump operations, ensuring
                efficient water distribution for agricultural and industrial
                applications, while minimizing energy consumption and maximizing
                productivity.
              </p>
              <NavLink to="/tube-well-pump-automation-services" className="know-more-btn">
                Know More
              </NavLink>
            </div>
            <div className="col tube-well-pump-automation-img-col img-col"></div>
          </div>
        </div>
        <hr />
        <div className="col flow-meter-monitoring-system-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <div className="row">
        <div className="col flow-meter-monitoring-system-img-col img-col"></div>
            <div className="col text-col even-text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" style={{textAlign:"right" ,borderRight:"1rem solid #304f85"}}>
              <h1>Flow Meter With Remote <br />Monitoring System </h1>
              <p>
              Unique Technologies is at the forefront of providing innovative flow meter solutions with remote monitoring capabilities. Our advanced systems offer real-time data insights, enabling efficient management of fluid resources. With tailored solutions, we empower industries to optimize operations, minimize wastage, and enhance productivity seamlessly.
              </p>
              <NavLink to="/flow-meter-automation-services" className="know-more-btn">
                Know More
              </NavLink>
            </div>
            
          </div>
        </div>
        <hr />
        <div className="col application-software-development-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <div className="row">
            <div className="col text-col odd-text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" style={{textAlign:"left" ,borderLeft:"1rem solid #304f85"}}>
              <h1>Application Software <br />Development </h1>
              <p>
                Unique Technologies excels in providing advanced street light
                automation services, leveraging state-of-the-art technologies to
                optimize energy usage and enhance safety in urban environments.
                With our innovative solutions, we enable efficient remote
                monitoring and control, ensuring well-lit streets while
                minimizing energy consumption and maintenance costs for
                municipalities and organizations.
              </p>
              <NavLink to="/application-software-services" className="know-more-btn">
                Know More
              </NavLink>
            </div>
            <div className="col application-software-development-img-col img-col"></div>
          </div>
        </div>
        <hr />
        <div className="col plc-hmi-scada-service-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <div className="row">
        <div className="col plc-hmi-scada-img-col img-col"></div>
            <div className="col text-col even-text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" style={{textAlign:"right" ,borderRight:"1rem solid #304f85"}}>
              <h1>PLC, HMI, Drive <br /> & SCADA</h1>
              <p>
              Unique Technologies specializes in providing comprehensive PLC, HMI, Drive, and SCADA services. Leveraging our expertise in automation technologies, we design, implement, and maintain customized solutions tailored to meet the specific needs of our clients across various industries, ensuring efficiency, reliability, and seamless integration of control systems.
              </p>
              <NavLink to="/plc-hmi-drive-and-scada" className="know-more-btn">
                Know More
              </NavLink>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPageSecondSection;
